export default {
  route: {
    dashboard: 'Dashboard',
    profile: 'profile',
    icons: 'icons',

    system: 'System',
    setting: 'Setting',
    config: 'Config',
    menu: 'Menu',
    attachment: 'Attachment',

    permission: 'Permission',
    admin: 'Admin',
    adminIndex: 'AdminIndex',
    authGroup: 'AuthGroup',
    authGroupTree: 'AuthGroupTree',
    authRule: 'AuthRule',
    authRuleTree: 'AuthRuleTree',
    adminLog: 'AdminLog',

    localExtension: 'LocalExtension',
    extension: 'Extension'
  },
  navbar: {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'System Login',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    captcha: 'Captcha',
    refreshCaptcha: 'Refresh Captcha',
    refreshCaptchaTip: 'Go Refresh Captcha'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },

  '清空缓存': 'Clear Cache',
  '清空网站缓存成功': 'Clear Cache Success',
  '提示': 'Tips',
  '确定': 'Ok',
  '取消': 'Canle',

  '提交': 'Save'
}
